import DashboardFiltersContainer from './containers/DashboardFiltersContainer';

export default DashboardFiltersContainer;
